import { GlobalLocation } from "../healthSystem/global-location";
import { Services } from "../practice/Services";
import { WorkingHours } from "../workinghours";

export class PractitionerServiceRequest {
  practitionerId: number;
  location: PLocation[];

}
export class PLocation {
  locationId: number;
  glocation: GlobalLocation;
  services:PServices[]
}
export class PServices {
  serviceId: number;
  serviceName: string;
  serviceType: string;
  workingHrs: ServiceWorkingHours[];
  subcategory: SubCategory[] = [];
}
export class SubCategory {
  subCategoryName: string;
  shortSummary: string;
  longDescription: string;
  subCategoryImages: string[]=[];
}

export class ServiceWorkingHours {
  Day: string;
  Hours: string[];
}
export class HealthSystemAddress {
  id: number;
  address: string;
}
